<section class="grid grid-cols-[1fr_auto] sm:grid-cols-[1fr_auto_1fr] items-center gap-2 px-4 sm:px-6">
  <div class="hidden sm:block"></div>
  <span class="text-left sm:text-center leading-tight"
    >&copy; {{ currentYear }} Capital Farm Credit. All rights reserved.
    <a
      href="https://www.capitalfarmcredit.com"
      target="_blank"
      rel="noopener"
      class="cfc-url"
      >www.capitalfarmcredit.com</a
    >
  </span>
  <div class="flex items-center justify-end">
    <img
      src="assets/images/common/cfc-logo.png"
      alt="CFC Logo"
      class="cfc-logo h-6 sm:h-8 md:h-10 w-auto"
    />
  </div>
</section>
